import { Checkbox, Modal } from 'antd';

import { openEULAPdf, openPrivatePolicy } from '../../../../../../utils/common';
import styles from '../../../Style/DatasetInfo.module.scss';

export const DownloadOptionsModal = ({
  visible,
  title,
  options,
  values,
  showWarn,
  checkPolicy,
  onCancel,
  onOk,
  onChange,
  onPolicyChange,
  setDisableDownload,
  setShowWarn,
}: {
  visible: boolean;
  title: string;
  options: Array<{ label: string; value: string }>;
  values: (string | number | boolean)[];
  showWarn: boolean;
  checkPolicy: boolean;
  downloadType: string | null;
  onCancel: () => void;
  onOk: () => void;
  onChange: (checkedValues: any[]) => void;
  onPolicyChange: (e: any) => void;
  disableDownload: boolean;
  setDisableDownload: (value: boolean) => void;
  setShowWarn: (value: boolean) => void;
}) => {
  return (
    <Modal
      className='download-modal'
      title={title}
      open={visible}
      onCancel={() => {
        setDisableDownload(false);
        setShowWarn(false);
        onCancel();
      }}
      onOk={onOk}
    >
      <div className={styles.fileFormats}>
        <p>Select file format(s) of time series data:</p>
        <Checkbox.Group
          key={new Date().getTime()}
          options={options}
          defaultValue={values}
          onChange={onChange}
        />
        <div className={styles.policyContainer}>
          <p
            className={
              styles.summaryInfo + ` ${showWarn && styles.summaryWarn}`
            }
          >
            <Checkbox defaultChecked={checkPolicy} onChange={onPolicyChange}>
              <span>
                I accept the{' '}
                <span
                  className={styles.summarySpecialText}
                  onClick={openEULAPdf}
                >
                  General EULA
                </span>{' '}
                and{' '}
                <span
                  className={styles.summarySpecialText}
                  onClick={openPrivatePolicy}
                >
                  Privacy Policy
                </span>
              </span>
              {showWarn && (
                <>
                  <br />
                  <span className={styles.summaryWarnText}>
                    Please tick checkbox to download.
                  </span>
                </>
              )}
            </Checkbox>
          </p>
        </div>
      </div>
    </Modal>
  );
};
